import { gql } from '@apollo/client';

import { exerciseFragment } from 'modules/exercises/graphql/fragments';

export const multipleChoiceExerciseFragment = gql`
  fragment MultipleChoiceExercise on Exercise {
    ...Exercise
    questions {
      id: _id
      _id
      text
      options {
        _id
        id: _id
        type
        text
      }
    }
  }
  ${exerciseFragment}
`;
